var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.4C4 4.6268 4.6268 4 5.4 4L11.6 4C12.3732 4 13 4.6268 13 5.4L13 8C13 8.55228 13.4477 9 14 9C14.5523 9 15 8.55229 15 8L15 5.4C15 3.52223 13.4778 2 11.6 2H5.4C3.52223 2 2 3.52223 2 5.4V18.6C2 20.4778 3.52223 22 5.4 22H11.6C13.4778 22 15 20.4778 15 18.6V16C15 15.4477 14.5523 15 14 15C13.4477 15 13 15.4477 13 16V18.6C13 19.3732 12.3732 20 11.6 20H5.4C4.6268 20 4 19.3732 4 18.6L4 5.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071C16.9024 15.3166 16.9024 14.6834 17.2929 14.2929L18.5858 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H18.5858L17.2929 9.70711C16.9024 9.31658 16.9024 8.68342 17.2929 8.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIconWhite);
export default __webpack_public_path__ + "static/media/sign-out-icon-white.45fca258be00ec48671674c053feac3f.svg";
export { ForwardRef as ReactComponent };